module.exports = __webpack_public_path__ + "media/images/step_circle_active-ba5009a22bb187b2469fd1c924d3b307.png";